@for (child of childrenQuestions; track child; let i = $index) {
  @if (i > 0) {
    <div class="hr-or">or</div>
  }
  <app-question-controller
    [question]="child"
    [showLabel]="true"
    (questionAnswer)="activateNextButton($event)">
  </app-question-controller>
}

@if (question.question_hint && question.question_bubble) {
  <p
    class="mt-30 mb-15 text-center">
    <a href="#question-modal" class="button-control button-control--opacity-hover" data-toggle="modal">
      <svg class="icon">
        <use xlink:href="#info-icon"></use>
      </svg>
      <span>{{question.question_hint}}</span></a>
    </p>
  }

